var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoveragesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 36.6663C20.0001 36.6663 33.3334 29.9997 33.3334 19.9997V8.33301L20.0001 3.33301L6.66675 8.33301V19.9997C6.66675 29.9997 20.0001 36.6663 20.0001 36.6663Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0003,
    cy: 20.3333,
    r: 8.33333,
    fill: "url(#paint0_linear_257_326)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_257_326",
    x1: 20.0003,
    y1: 12,
    x2: 20.0003,
    y2: 28.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoveragesLogo);
export default __webpack_public_path__ + "static/media/CoveragesLogo.b06e9af7a0b3a21b7ad9fea7e188bfc4.svg";
export { ForwardRef as ReactComponent };